var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradientHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5150_96417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6338 6.63086V11.6287",
    stroke: "url(#paint0_linear_5150_96417)",
    strokeWidth: 1.81035,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9653 14.1279L11.6338 11.6289",
    stroke: "url(#paint1_linear_5150_96417)",
    strokeWidth: 1.81035,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4863 8.682H21.6512V4.51709",
    stroke: "url(#paint2_linear_5150_96417)",
    strokeWidth: 1.81035,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1103 18.105C16.8292 19.3872 15.1965 20.2607 13.4189 20.6148C11.6413 20.969 9.79861 20.7879 8.12389 20.0947C6.44917 19.4014 5.0177 18.2269 4.01055 16.72C3.0034 15.213 2.46582 13.4412 2.46582 11.6286C2.46582 9.81607 3.0034 8.04424 4.01055 6.53727C5.0177 5.03029 6.44917 3.85588 8.12389 3.16259C9.79861 2.46929 11.6413 2.28828 13.4189 2.64243C15.1965 2.99659 16.8292 3.87 18.1103 5.15219L21.6505 8.68195",
    stroke: "url(#paint3_linear_5150_96417)",
    strokeWidth: 1.81035,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5150_96417",
    x1: 12.5516,
    y1: 8.21359,
    x2: 11.6201,
    y2: 8.23191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317304,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5150_96417",
    x1: 15.6092,
    y1: 12.4203,
    x2: 11.687,
    y2: 13.0885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317304,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5150_96417",
    x1: 21.3089,
    y1: 5.83604,
    x2: 17.4651,
    y2: 6.21382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317304,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5150_96417",
    x1: 20.0734,
    y1: 8.26918,
    x2: 2.38442,
    y2: 10.0893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317304,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5150_96417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6818,
    height: 21.6818,
    fill: "white",
    transform: "translate(0.65918 0.65918)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientHistoryIcon);
export default __webpack_public_path__ + "static/media/gradient_history_icon.210d983d7d4abf4f13c90f956437b1c1.svg";
export { ForwardRef as ReactComponent };